import React, {  Component } from 'react';

export default class LineNoMissingFromBackOrdersOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.removeMissingLineNumberItems();
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        // const self = this;
        // const { lineNoMissing } = self.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <h2 className="title">Line Number Missing Items</h2>
					{/* lineNoMissing && lineNoMissing.map((item, index) => {
                        return <p key={index}>
                            Your order contains missing line number backorders for {item.item} from order {item.originalOrderNumber}.
                        </p>
                    })*/ }
                    <p>Deleting backorder available items because of an issue with line number. Add them again to the order</p>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/lineNoMissingFromBackOrdersOverlayDialog.js